import React from 'react'
import { ListNotices } from '@core/Areas/VenueMode/Components/Notices/Notices.styles'
import { LOCATION_DISABLED_TEXT, LOCATION_DISABLED_TITLE } from '@core/Areas/VenueMode/constants'

export const ImpreciseNoticeAndroid = (): React.JSX.Element => {
  return (
    <>
      <b>{LOCATION_DISABLED_TITLE}</b>
      <br />
      <i>{LOCATION_DISABLED_TEXT}</i>
      <br />
      <b>1. Enable location services for your device and Chrome</b>
      <ListNotices>
        <li>
          Open phone <b>Settings → Location</b> and toggled <b>ON</b>.
        </li>
        <li>
          Go back to <b>Settings → Apps</b> and select <b>Chrome</b>
        </li>
        <li>
          Tap <b>Permissions → Location</b> and choose <b>"Allow only while using the app</b>"
        </li>
        <li>
          Ensure <b>Precise Location</b> is enabled
        </li>
      </ListNotices>
      <br />
      <b>2. Re‑enable location access for TABtouch after it was denied </b>
      <br />
      If you have denied location access for TABtouch previously, Chrome will not automatically
      prompt again and you'll need to reset site permissions.
      <ListNotices>
        <li>
          In the <b>Chrome</b> browser, tap the <b>Filter/Settings Icon → Permissions</b>
        </li>
        <li>
          Tap <b>Location</b> and choose <b>Allowed</b>
        </li>
      </ListNotices>
      <br />
      <b>3. Refresh the page</b>
    </>
  )
}
